import { type VideoPlayer, createVideoPlayer } from 'expo-video';
import { Platform } from 'react-native';

// Creates a hero video player with the shared config. Used both for the
// bootstrap warm-up (`preloadHeroVideo`) and as the fallback when a layer
// mounts without a preloaded instance.
export function createHeroVideoPlayer(uri: string): VideoPlayer {
  // Caching is disabled on iOS
  const player = createVideoPlayer({ uri, useCaching: Platform.OS !== 'ios' });
  player.loop = true;
  player.muted = true;
  player.play();
  return player;
}

// A single hero player warmed at app bootstrap so the first paint reads from a
// filled buffer (iOS — in memory) or the disk cache (Android) instead of a cold
// network fetch.
let preloaded: { uri: string; player: VideoPlayer } | null = null;

export function preloadHeroVideo(uri: string): void {
  if (preloaded?.uri === uri) {
    return; // already warming
  }
  // Source changed (e.g. the CMS swapped the hero video) — drop the stale one.
  preloaded?.player.release();
  preloaded = { uri, player: createHeroVideoPlayer(uri) };
}

export function takePreloadedHeroVideo(uri: string): VideoPlayer | null {
  if (preloaded?.uri === uri) {
    const { player } = preloaded;
    preloaded = null;
    return player;
  }
  return null;
}
